import makeStyles from '@mui/styles/makeStyles';

export const BARHEIGHT = 14;
export const BARWIDTH = 40;
export const COLORS = {
  reallightGray: '#f1f1f1ff',
  lightGray: '#DFDFDF',
  darkGrey: '#A0A0A1',
  green: '#61EB4F',
  red: '#FF0000',
}

const useStyles = makeStyles((theme) => ({
  icon: {
    cursor: 'pointer',
    pointerEvents: 'all',
    paddingRight: theme.spacing(.5),
  },
  iconDisabled: {
    cursor: 'default',
    pointerEvents: 'none',
    paddingRight: theme.spacing(.5),
  },

  compare: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: BARWIDTH + 35,
    marginRight: theme.spacing(1),
    padding: theme.spacing(1),

    '&.compareHover': {
      '&:hover': {
        backgroundColor: COLORS.reallightGray,
        cursor: 'pointer',
        borderRadius: 5,
      },
    },

    '& .barContainer': {
      display: 'flex',
      flexDirection: 'row',
      width: BARWIDTH,
      height: BARHEIGHT,
      border: `1px solid ${COLORS.lightGray}`,
      position: 'relative',
    },

    '& .bar': {
      backgroundColor: COLORS.lightGray,
      position: 'relative',
    },

    '& .text': {
      fontSize: 12,
      marginLeft: 5,
    }
  },

  compareModal: {
    '& .container': {
      padding: theme.spacing(1),
      maxWidth: 450,
      minWidth: 320,
      minHeight: 400,
    },

    '& .header': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    }
  }
}));

export default useStyles;
